import {
  Button,
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { useEffect, useState } from "react";
import TableButton from "./TableButton";
import { theme } from "../../Assets/Theme/theme";
import StatusBadge from "./StatusBadge";
import CloseIcon from "@mui/icons-material/Close";
import CustomCalendar from "../../Components/Common/CustomCalendar";
import CustomButton from "../../Components/Common/CustomButton";
import { formateDateDDMMYY } from "../../Services/formatDate";
import { BASE_URL } from "../../Assets/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const PaginationDataTable = ({
  columns,
  rows,
  editAndDelete = false,
  onEdit,
  onDelete,
  handleCheckboxChange,
  setRefresh,
  currentPage,
  setCurrentPage,
  noDelete
}) => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedId, setSelectedId] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState(null);


  const handleOpen = (id) => {
    const selectedRow = rows.find((row) => row.id === id);
    if (selectedRow) {
      setSelectedDate(selectedRow.date);
      setSelectedId(id);
      setOpen(true);
    }
  };


  const handleClose = () => {
    setSelectedId(null);
    setOpen(false);
  };

  const handlechangepage = (event, newPage) => {
    setCurrentPage(newPage);
  }

  const [rowperpage] = useState(10);

  return (
    <Paper
      sx={{
        boxShadow: 0,
      }}
    >
      <TableContainer
        sx={{
          paddingTop: 1,
          borderRadius: 2,
          boxShadow: 0,
        }}
      >
        <Table
          stickyHeader
          sx={{
            borderCollapse: "separate",
            borderSpacing: "0 15px",
            boxShadow: 0,
          }}
        >
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  sx={{
                    fontWeight: "bold",
                    borderBottom: "none",
                    textAlign: "center",
                    minWidth: 120,
                    fontSize: "16px",
                  }}
                >
                  {column.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length > 0 ?
              rows
                .slice(currentPage * rowperpage, currentPage * rowperpage + rowperpage)
                .map((row, i) => (
                  <TableRow
                    key={i}
                    sx={{
                      backgroundColor: "#f9f9f9",
                      borderRadius: 2,
                      border: "1px solid #EAEAEA",
                      "& td": {
                        padding: "16px",
                        borderBottom: "none",
                      },
                    }}
                    onMouseEnter={() => {
                      setHoveredRowId(row._id);
                    }}
                    onMouseLeave={() => setHoveredRowId(null)}
                  >
                    {columns &&
                      columns.map((column, j) => {
                        let value = row[column.id];

                        const isFourthColumn = j === 3;
                        const displayValue =
                          isFourthColumn && row.currency
                            ? `${row.currency}${value}`
                            : value;



                        return column.id === "status" ? (
                          <TableCell key={j} sx={{ textAlign: "center" }}>
                            <StatusBadge status={value} />
                          </TableCell>
                        ) : column.id === "statusAction" ? (
                          <TableCell key={j} sx={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              disabled={!row.canModify}
                              onClick={() => {
                                if (row.canModify) {
                                  handleOpen(row?.id);
                                }
                              }}
                              sx={{
                                backgroundColor: row.canModify
                                  ? theme.colors.orange
                                  : theme.colors.grey,
                                color: "white",
                                "&:hover": {
                                  backgroundColor: row.canModify
                                    ? theme.colors.darkBlue
                                    : theme.colors.grey,
                                },
                              }}
                            >
                              Modify
                            </Button>
                          </TableCell>
                        ) : column.id === "S.no" ? (
                          <TableCell
                            key={j}
                            sx={{
                              textAlign: "center",
                              fontWeight: 700,
                            }}
                          >
                            {currentPage * rowperpage + i + 1}
                          </TableCell>
                        ) : !row[column.id] && editAndDelete ? (
                          <TableCell
                            key={j}
                            sx={{
                              display: "flex",
                              gap: 2,
                              justifyContent: "center",
                              marginTop: 1
                            }}
                          >
                            {column.id === "destination" ? "undefined" : (
                              row.status === "USED" ? (
                                "-"
                              ) : (
                                <>
                                  <TableButton
                                    color={theme.colors.text}
                                    onClick={() => onEdit && onEdit(row)}
                                    fontWeight="400"
                                    hover={hoveredRowId === row.id}
                                  >
                                    Edit{" "}
                                  </TableButton>
                                 {!noDelete &&  <TableButton
                                    color={theme.colors.red}
                                    onClick={() => onDelete && onDelete(row)}
                                    fontWeight="400"
                                  >
                                    Delete
                                  </TableButton>}
                                </>
                              )
                            )}
                          </TableCell>
                        )

                          : (
                            <TableCell
                              key={j}
                              sx={{
                                cursor: "pointer",
                                textAlign: "center",
                                textTransform:
                                  column.id === "user" && "capitalize",
                                fontWeight:
                                  column.id === "bookings" ||
                                    column.id === "totalRevenue" ||
                                    column.id === "barcode" ||
                                    column.id === "Status"
                                    ? 700
                                    : 400,
                              }}
                            >
                              {column.id === "totalRevenue"
                                ? `$${displayValue}`
                                : displayValue}
                            </TableCell>
                          );
                      })}
                  </TableRow>
                )) : <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "gray",
                    fontSize: "1.2rem",
                    marginTop: "2rem",
                    position: "absolute", left: "50%"
                  }}
                >
                No data available
              </Box>}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPage={rowperpage}
        page={currentPage}
        count={rows.length}
        component="div"
        onPageChange={handlechangepage}
        sx={{
          "& .MuiSelect-icon": {
            display: "none",
          },
          "& .MuiTablePagination-toolbar": {
            display: "flex",
            justifyContent: "flex-end",
          },

          "& .MuiTablePagination-selectLabel,  & .MuiTablePagination-select , & .css-1brww8i-MuiInputBase-root-MuiTablePagination-select":
          {
            display: "none",
          },
          "& .MuiTablePagination-actions button:enabled": {
            color: "orange",
          },
        }}
      />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="change-date-title"
        PaperProps={{
          sx: {
            width: "400px",
            maxWidth: "90%",
            borderRadius: "12px",
          },
        }}
      >
        <DialogTitle
          id="change-date-title"
          sx={{
            fontSize: "24px",
            fontWeight: 700,
            color: theme.colors.text,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Change Date
          <IconButton
            onClick={handleClose}
            sx={{
              color: theme.colors.text,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CustomCalendar
              minDate={new Date()}
              selectedRowId={rows.find((row) => row.id === selectedId)?.date}
              selectedDate={selectedDate}
              onDateChange={(date) => setSelectedDate(formateDateDDMMYY(date))}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Box width={"50%"} sx={{ marginRight: "30px" }}>
            <CustomButton
              onClick={async () => {
                const loginData = JSON.parse(localStorage.getItem("adminData"));
                const token = loginData?.token;

                if (!token) {
                  toast.error("Authentication token is missing", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                  navigate('/login')
                  return;
                }

                if (!selectedId) {
                  console.error("Selected ID not found!");
                  return;
                }

                try {
                  const response = await axios.put(
                    `${BASE_URL}/admin/booking/${selectedId}/update-date`,
                    {
                      date: selectedDate,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  setRefresh((prev) => !prev);
                  handleClose();
                } catch (error) {
                  console.error(
                    "Error calling the API:",
                    error?.response?.data?.errors[0]?.msg
                  );
                  toast.error(error?.response?.data?.errors[0]?.msg, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  });
                }
              }}
            >
              Save
            </CustomButton>
          </Box>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export default PaginationDataTable;
